export const ROUTES = {
  // Public routes that shouldn't load AppProviders
  PROVIDER_REGISTER: "/provider/register/",
  PROVIDER_REGISTER_API: "/api/v1/provider/register/",
  LOGIN: "/login/",
  REGISTER: "/register/",
  REGISTER_API: "/api/v1/register/",
  PASSWORD_RESET: "/password-reset/",
  PASSWORD_RESET_CONFIRM: "/password-reset-confirm/",
  LOADING: "/loading/",
  // Treatment/ungated RX routes
  TREATMENTS_LOGIN: "/treatments/login/",
  TREATMENTS_REGISTER: "/treatments/register/",
  // Male partner routes
  MALE_PARTNER_ELIGIBILITY: "/register/male-partner/eligibility/",
  MALE_PARTNER_REGISTER: "/register/male-partner/",
  MALE_PARTNER_LOGIN: "/login/male-partner/",
  // Local gallery. The page is registered only under npm start.
  UI_GALLERY: "/ui/",
  // Magic link routes
  PROVIDER_TEST: "/provider-test/",
  PROVIDER_TEST_API: "/api/v1/provider-test/",
} as const;
